import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IPreCheckDeliverablesRequest } from "@shared/lib/types/brief";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_INFLUENCER_V2_PRE_CHECK_DELIVERABLES_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function usePreCheckDeliverables(params: IPreCheckDeliverablesRequest) {
  const { data, isFetching, isSuccess, isError, error, refetch } = useQuery<
    BackednResponse<
      {
        status: "failed" | "success" | "warning";
        briefInfluencerId: string;
        reason: string;
        briefInfluencer: IBriefInfluencerV2;
      }[]
    >
  >({
    queryKey: [...BRIEF_INFLUENCER_V2_PRE_CHECK_DELIVERABLES_QUERY_KEY, params],
    queryFn: () => BriefService.preCheckDeliverables({ ...params }),
    enabled: !!params.deliverableV2Id,
    staleTime: 0,
  });

  const errorMessage = error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    preCheckDeliverables: data?.data || [],
    isFetching,
    isSuccess,
    isError,
    error,
    refetch,
  };
}
